module.exports = __webpack_public_path__ + "img/packetgrup-large.bb5a6ad7.png";